import React from "react";
import { ImageWrap, OnBoardingLayoutWrap } from "components/atoms/Auth/OnBoardingLayout/OnBoardingLayout.styles";
import { FormWrap } from "components/atoms/Auth/Auth.styles";
import login from "assets/Login/loginImg.png";
const OnBoardingLayout = ({ children, img = login, heading }) => {
  return (
    <OnBoardingLayoutWrap>
      <FormWrap>{children}</FormWrap>
      <ImageWrap>
        {!heading && (
          <h1 className="textWrap">
            Increase sales <br /> with Plates!
          </h1>
        )}
        <img src={img} alt="login" />
      </ImageWrap>
    </OnBoardingLayoutWrap>
  );
};
export default OnBoardingLayout;
